import { type DateValue } from '@mantine/dates'
import { DateTime } from 'luxon'

export function getDateFromDateValue(value: DateValue): Date | null {
  if (!value) return null
  if (value instanceof Date) return value
  const withTime = DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss')
  if (withTime.isValid) return withTime.toJSDate()
  return DateTime.fromFormat(value, 'yyyy-MM-dd').toJSDate()
}

export function getMillisFromDateValue(value: DateValue): number | null {
  const date = getDateFromDateValue(value)
  if (!date) return null
  return date.getTime()
}

export function getDateTimeFromDateValue(value: DateValue): DateTime | null {
  const date = getDateFromDateValue(value)
  if (!date) return null
  return DateTime.fromJSDate(date)
}
